import type AuthenticationContext from './AuthenticationContext'
import authorizationHeaders from './authorizationHeaders'
import requireAuthContext from './requireAuthContext'

type UrlResolver = string | ((authContext: AuthenticationContext) => string)

const fetchAuthorized = async (url: UrlResolver, init?: RequestInit): Promise<Response> => {
  const authContext = await requireAuthContext()
  const resolvedUrl = typeof url === 'function' ? url(authContext) : url
  return fetch(resolvedUrl, {
    ...init,
    headers: {
      ...init?.headers,
      ...authorizationHeaders(authContext),
    },
  })
}

export default fetchAuthorized
